import { render, staticRenderFns } from "./NewsPageComponent.vue?vue&type=template&id=f10d4c1a&scoped=true&"
import script from "./NewsPageComponent.vue?vue&type=script&lang=js&"
export * from "./NewsPageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f10d4c1a",
  null
  
)

export default component.exports